import React, { FC } from 'react';
import { useAppSelector } from '../../../../hooks/redux';
import { ReactComponent as WalletLightIcon } from '../../../../assets/images/WalletLightSidevar.svg';
import { ReactComponent as WalletDarkIcon } from '../../../../assets/images/WalletDarkSidebar.svg';

export const WalletIcon: FC = () => {
  const { theme } = useAppSelector((state) => state.appReducer);

  const getIcon = (colorTheme: string) => {
    switch (colorTheme) {
      case 'light': {
        return <WalletLightIcon />;
      }
      case 'dark': {
        return <WalletDarkIcon />;
      }
      default: {
        return <WalletLightIcon />;
      }
    }
  };
  return getIcon(theme);
};
